import router from '@iez/core/router'
import { state } from '..'

router.beforeEach((to, from, next) => {
  if (state.snackbar && !state.snackbar.afterEnter) {
    state.snackbar.remove()
  }
  next()
})

router.afterEach((to, from) => {
  if (state.snackbar && state.snackbar.afterEnter) {
    state.snackbar.afterEnter = false
  }
})
